import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchIntakesByClientId } from "../../store/thunks/intakeThunk";
import IntakeDetailsModal from "../intakesPage/IntakeDetailsModal";

const ClientIntake = () => {
  const dispatch = useDispatch();
  const [selectedIntake, setSelectedIntake] = useState(null);
  const client = useSelector((state) => state.clients.selectedClient);
  const [clientIntakes, setClientIntakes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIntakes = async () => {
      if (client?._id) {
        setLoading(true);
        try {
          const result = await dispatch(fetchIntakesByClientId(client._id)).unwrap();
          setClientIntakes(result);
        } catch (error) {
          console.error("Error fetching intakes:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchIntakes();
  }, [client?._id, dispatch]);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-pulse flex space-x-4">
          <div className="rounded-sm bg-gray-200 h-12 w-12"></div>
          <div className="flex-1 space-y-2 py-1">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!clientIntakes || clientIntakes.length === 0) {
    return (
      <div className="bg-white rounded-sm shadow-sm border border-gray-200 p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-sm bg-gray-100">
            <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="mt-2 text-sm font-medium text-gray-900">No intake forms</h3>
          <p className="mt-1 text-sm text-gray-500">No intake forms found for this client.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-sm shadow-sm border border-gray-200 p-4 cursor-pointer hover:bg-gray-50 transition-colors"
           onClick={() => setSelectedIntake(clientIntakes[0])}>
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base font-medium text-gray-900 mb-1">Intake Form</h3>
            <div className="text-sm text-gray-500 space-y-0.5">
              <p>Status: <span className="font-medium">{clientIntakes[0].statusHistory[clientIntakes[0].statusHistory.length - 1].status}</span></p>
              <p>Last Updated: <span className="font-medium">{new Date(clientIntakes[0].statusHistory[clientIntakes[0].statusHistory.length - 1].modifiedAt).toLocaleDateString()}</span></p>
            </div>
          </div>
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>

      {selectedIntake && (
        <IntakeDetailsModal
          intake={selectedIntake}
          onClose={() => setSelectedIntake(null)}
        />
      )}
    </div>
  );
};

export default ClientIntake; 